import { SimpleBars } from '../../Common/Charts/SimpleBars';
import { useFinancingChartsDataContext } from './hooks/useFinancingChartsDataContext';
import { coresMescladasArray } from '../../Common/styles/colors';

export const FinancingNatureBySource = () => {
    const { chartData } = useFinancingChartsDataContext();

    const naturezaPorFonte = chartData?.natureBySource || {};
    const sources = Object.keys(naturezaPorFonte).sort();

    const natureSet = new Set();
    sources.forEach((source) => {
        Object.keys(naturezaPorFonte[source] || {}).forEach((nature) => natureSet.add(nature));
    });
    const natures = Array.from(natureSet);

    const series = natures.map((nature) => ({
        name: nature,
        data: sources.map((source) => naturezaPorFonte[source]?.[nature] ?? 0)
    }));
    const colors = natures.map((_, index) => coresMescladasArray[index % coresMescladasArray.length]);

    return (
        <SimpleBars
            title={'Natureza x Fonte de Remuneração'}
            subtitles={sources}
            series={series}
            customColors={colors}
        />
    );
};
